import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "absolute top-0 right-0 mt-4 mr-5" };
const _hoisted_2 = { class: "flex-1 my-4 overflow-auto" };
const _hoisted_3 = { class: "min-h-4 mb-3px" };
import { computed, watch, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { gsap } from 'gsap';
import { useRetroStore } from '@/pinia_stores/retro';
import constants from '@/constants';
import tailwindUnits from '@/helpers/tailwindUnits';
import UserFocus from '@/components/topics/UserFocus.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TopicTemplate',
    props: {
        description: { type: String, default: null },
        topicType: { type: Object, required: true },
        stripeColor: { type: String, required: true },
        user: { type: Object, default: null },
        focusedUsers: { type: Array, default: () => [] },
        highlight: { type: Boolean, default: false },
        draggable: { type: Boolean, default: false },
        stacked: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const retroStore = useRetroStore();
        const { activity } = storeToRefs(retroStore);
        const card = ref(null);
        const leftStripe = ref(null);
        // A public topic must have a height that's divisible by 20.
        const lineHeight = 5;
        const lineHeightPx = tailwindUnits.toPx(lineHeight);
        const backgroundStyle = computed(() => props.highlight ? 'bg-white dark:bg-gray-600' : 'bg-white dark:bg-gray-700');
        const borderStyle = computed(() => (props.stacked ? '' : 'border rounded-lg'));
        const dragStyle = computed(() => (props.draggable ? 'cursor-move handle' : ''));
        const shadowStyle = computed(() => (props.highlight && !props.stacked ? 'shadow-200' : ''));
        const cardClasses = computed(() => [backgroundStyle.value, borderStyle.value, dragStyle.value, shadowStyle.value].join(' '));
        function animateStripeColor() {
            gsap.to(leftStripe.value, {
                duration: constants.SPEED.fastest,
                borderColor: props.stripeColor
            });
        }
        function animateMarginBottom() {
            if (props.stacked) {
                gsap.set(card.value, { marginBottom: 0 });
            }
            else {
                gsap.to(card.value, { duration: constants.SPEED.normal, marginBottom: lineHeightPx });
            }
        }
        onMounted(() => {
            animateStripeColor();
            animateMarginBottom();
        });
        watch(() => props.stripeColor, () => {
            animateStripeColor();
        });
        watch(() => props.stacked, () => {
            animateMarginBottom();
        });
        return (_ctx, _cache) => {
            const _component_avatar = _resolveComponent("avatar");
            const _component_user_entered_text = _resolveComponent("user-entered-text");
            return (_openBlock(), _createBlock(UserFocus, { "focused-users": __props.focusedUsers }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        ref_key: "card",
                        ref: card,
                        class: _normalizeClass(["relative w-full overflow-hidden border-gray-300 dark:border-gray-900", _unref(cardClasses)])
                    }, [
                        _createElementVNode("div", {
                            ref_key: "leftStripe",
                            ref: leftStripe,
                            class: "flex flex-col h-full px-5 pt-4 pb-3 border-transparent border-l-7"
                        }, [
                            _createElementVNode("div", _hoisted_1, [
                                (__props.user)
                                    ? (_openBlock(), _createBlock(_component_avatar, {
                                        key: 0,
                                        user: __props.user,
                                        size: "sm"
                                    }, null, 8, ["user"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("p", {
                                class: _normalizeClass(["text-xs leading-tight capitalize-first dark:text-gray-400", `text-${__props.topicType.color}`])
                            }, _toDisplayString(_ctx.$t(`activities.${_unref(activity).id}.topic_types.${__props.topicType.name}.name`)), 3),
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_user_entered_text, {
                                    class: "leading-snug",
                                    text: __props.description
                                }, null, 8, ["text"])
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                                _renderSlot(_ctx.$slots, "actions")
                            ])
                        ], 512)
                    ], 2)
                ], undefined, true),
                _: 3
            }, 8, ["focused-users"]));
        };
    }
});
